// extracted by mini-css-extract-plugin
export default {"not__found":"NotFound_not__found__SkqXD","error":"NotFound_error__N15dH"};